var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVarianticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5405_12187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.6154C13.2058 16.6154 16.6154 13.2058 16.6154 9C16.6154 4.79423 13.2058 1.38462 9 1.38462C4.79423 1.38462 1.38462 4.79423 1.38462 9C1.38462 13.2058 4.79423 16.6154 9 16.6154ZM9 18C13.9708 18 18 13.9708 18 9C18 4.02923 13.9708 0 9 0C4.02923 0 0 4.02923 0 9C0 13.9708 4.02923 18 9 18Z",
    fill: "url(#paint0_linear_5405_12187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C4.73478 6.5 4.48043 6.39464 4.29289 6.20711C4.10536 6.01957 4 5.76522 4 5.5C4 5.23478 4.10536 4.98043 4.29289 4.79289C4.48043 4.60536 4.73478 4.5 5 4.5C5.26522 4.5 5.51957 4.60536 5.70711 4.79289C5.89464 4.98043 6 5.23478 6 5.5C6 5.76522 5.89464 6.01957 5.70711 6.20711C5.51957 6.39464 5.26522 6.5 5 6.5ZM5 6.5V11.5M12 11.5C12.2652 11.5 12.5196 11.6054 12.7071 11.7929C12.8946 11.9804 13 12.2348 13 12.5C13 12.7652 12.8946 13.0196 12.7071 13.2071C12.5196 13.3946 12.2652 13.5 12 13.5C11.7348 13.5 11.4804 13.3946 11.2929 13.2071C11.1054 13.0196 11 12.7652 11 12.5C11 12.2348 11.1054 11.9804 11.2929 11.7929C11.4804 11.6054 11.7348 11.5 12 11.5ZM12 11.5V6.5M12 6.5C11.7348 6.5 11.4804 6.39464 11.2929 6.20711C11.1054 6.01957 11 5.76522 11 5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5C12.2652 4.5 12.5196 4.60536 12.7071 4.79289C12.8946 4.98043 13 5.23478 13 5.5C13 5.76522 12.8946 6.01957 12.7071 6.20711C12.5196 6.39464 12.2652 6.5 12 6.5ZM5 11.5C5.26522 11.5 5.51957 11.6054 5.70711 11.7929C5.89464 11.9804 6 12.2348 6 12.5C6 12.7652 5.89464 13.0196 5.70711 13.2071C5.51957 13.3946 5.26522 13.5 5 13.5C4.73478 13.5 4.48043 13.3946 4.29289 13.2071C4.10536 13.0196 4 12.7652 4 12.5C4 12.2348 4.10536 11.9804 4.29289 11.7929C4.48043 11.6054 4.73478 11.5 5 11.5ZM5.75 11.75L11.25 6.25",
    stroke: "url(#paint1_linear_5405_12187)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5405_12187",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5405_12187",
    x1: 8.5,
    y1: 4.5,
    x2: 8.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470A9D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5405_12187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarianticon);
export default __webpack_public_path__ + "static/media/varianticon.e9a1c80f40f8395b4f089e5420dab7dc.svg";
export { ForwardRef as ReactComponent };